import { render } from "./StatusComponent.vue?vue&type=template&id=2dc0e06b"
import script from "./StatusComponent.vue?vue&type=script&lang=js"
export * from "./StatusComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__